import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Container,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { PageIndices, TabIndices } from '../common/i-doc/i-doc.registry.ts';
import { PageHint } from '../components/common/PageHint';
import { DashboardLayout } from '../components/DashboardLayout';
import { MedicationsTab } from './LibraryPage/MedicationsTab';
import { WorkoutsTab } from './LibraryPage/WorkoutsTab';
import { FoodTab } from './LibraryPage/FoodTab';
import { MetActivitiesTab } from './LibraryPage/MetActivitiesTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  tabId?: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, tabId, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`library-tabpanel-${index}`}
      aria-labelledby={`library-tab-${index}`}
      {...(tabId ? { 'data-i-doc': tabId } : {})}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const TAB_SLUGS = ['medications', 'workouts', 'food', 'met-activities'];

export const LibraryPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabSlug = searchParams.get('tab');
  const currentTab = Math.max(0, TAB_SLUGS.indexOf(tabSlug ?? '')) || 0;

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: TAB_SLUGS[newValue] }, { replace: true });
  };

  return (
    <DashboardLayout>
      <Container maxWidth="lg" data-i-doc={PageIndices.LIBRARY}>
        <PageHint iDoc={PageIndices.LIBRARY} />
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={currentTab} onChange={handleTabChange} aria-label="library tabs">
              <Tab label="Препарати"     id="library-tab-0" />
              <Tab label="Тренування"    id="library-tab-1" />
              <Tab label="Їжа"           id="library-tab-2" />
              <Tab label="MET Активності" id="library-tab-3" />
            </Tabs>
          </Box>
          <TabPanel value={currentTab} index={0} tabId={TabIndices.LIBRARY_MEDICATIONS}>
            <PageHint iDoc={TabIndices.LIBRARY_MEDICATIONS} />
            <MedicationsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={1} tabId={TabIndices.LIBRARY_WORKOUTS}>
            <PageHint iDoc={TabIndices.LIBRARY_WORKOUTS} />
            <WorkoutsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={2} tabId={TabIndices.LIBRARY_FOOD}>
            <PageHint iDoc={TabIndices.LIBRARY_FOOD} />
            <FoodTab />
          </TabPanel>
          <TabPanel value={currentTab} index={3} tabId={TabIndices.LIBRARY_MET_ACTIVITIES}>
            <PageHint iDoc={TabIndices.LIBRARY_MET_ACTIVITIES} />
            <MetActivitiesTab />
          </TabPanel>
        </Box>
      </Container>
    </DashboardLayout>
  );
};
